/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".example-margin[_ngcontent-%COMP%] {\r\n    margin: 0 10px;\r\n  }"];
export { styles as styles };
